export default "__VITE_ASSET__CkCMuuY7__"